import {
  Box,
  Button,
  Flex,
  Link,
  useDisclosure,
  Image,
  HStack,
  Center,
  Text,
  VStack,
  SimpleGrid,
  Grid,
  GridItem,
  useBreakpointValue,
  Show,
  Hide,
} from "@chakra-ui/react";
import aboutBanner from "@/assets/images/about_banner.png";
import aboutTitle1 from "@/assets/images/about_title1.png";
import aboutImage1 from "@/assets/images/aboutimage1.png";
import aboutTitle2 from "@/assets/images/about_title2.png";
import aboutImage2 from "@/assets/images/aboutimage2.png";
import aboutBg from "@/assets/images/about_thing_bg.png";
import aboutTitle3 from "@/assets/images/about_title3.png";
import companyTimeLine from "@/assets/images/company_timeline.png";

const About = () => {
  return (
    <Box>
      <Box position={"relative"}>
        <Image w="100%" src={aboutBanner} />
      </Box>
      <Center mt="80px">
        <Image src={aboutTitle1} />
      </Center>
      <Box w="80%" m="0 auto">
        <Hide above="lg"><Center><Image maxW={"100%"} src={aboutImage1} /></Center></Hide>
        <Flex alignItems={"flex-start"} gap={10}>
          <Show above="lg"><Image maxW={"100%"} src={aboutImage1} /></Show>
          
          <Box mt="20px" fontSize="18px" color={"#27314D"} lineHeight="40px">
              <Box>
              壹仟零壹艺数智（北京）科技有限公司，即一千零一艺（ART1001），国家高新技术企业、北京市专精特新中小企业。2015年成立以来，一直致力于新信息技术与数字经济的融合创新。成功研发了阿拉丁ALDCAD、ALD3D、ALDBIM、ALDGPT和太行AI等软件系统，构建了建筑业数智化产品集、数智化解决方案、数智化设计服务、数智化施工与管理、数智化人才培养等全产业链数智化服务闭环。并将这些技术与服务深度融入EPC总承包服务流程，实现了工程设计、采购、施工管理的一体化高效运作。主编并发布了行业核心标准——《建筑装饰装修工程BIM设计标准》，填补了建筑装饰行业标准的空白。此外，公司是教育部"1+X"建筑装饰装修数字化设计职业技能等级证书培训评价组织。至今，累计获得发明专利、软件著作权及各项资质荣誉近百项，已成为中国建筑业数智化变革的推动者和领军企业。
              </Box>
            </Box>
        </Flex>
      </Box>
      <Box mt="55px" overflow={"hidden"} bg={"rgba(238, 241, 247, 0.5)"}>
        <Center mt="80px">
          <Image src={aboutTitle2} />
        </Center>

        <Box w="80%" m="0 auto">
          <Flex mb="30px" gap={"30px"}>
            <Box flex={1} bg="#fff" minH={"294px"} position="relative">
              <Text
                position={"absolute"}
                top="0"
                left="0"
                lineHeight={"120px"}
                fontWeight="bold"
                fontSize={"144px"}
                color={"rgba(238, 241, 247, 0.5)"}
              >
                01
              </Text>
              <Flex
                ml="80px"
                mr="40px"
                h="100%"
                alignItems={"center"}
                position={"relative"}
              >
                <Box w="100%">
                  <Text
                    mb="20px"
                    color={"#496AE1"}
                    fontSize="30px"
                    fontWeight={"bold"}
                  >
                    VALUE
                  </Text>
                  <Text mb="20px" color={"#3D3D3D"} fontSize="36px">
                    价值观
                  </Text>
                  <Text color={"#3D3D3D"} fontSize="20px">
                    创新、引领、开放、诚信、共生
                  </Text>
                </Box>
              </Flex>
            </Box>
            <Box flex={1} bg="#fff" minH={"294px"} position="relative">
              <Text
                position={"absolute"}
                top="0"
                left="0"
                lineHeight={"120px"}
                fontWeight="bold"
                fontSize={"144px"}
                color={"rgba(238, 241, 247, 0.5)"}
              >
                02
              </Text>
              <Flex
                ml="80px"
                mr="40px"
                h="100%"
                alignItems={"center"}
                position={"relative"}
              >
                <Box w="100%">
                  <Text
                    mb="20px"
                    color={"#496AE1"}
                    fontSize="30px"
                    fontWeight={"bold"}
                  >
                    MISSION
                  </Text>
                  <Text mb="20px" color={"#3D3D3D"} fontSize="36px">
                    使命
                  </Text>
                  <Text color={"#3D3D3D"} fontSize="20px">
                    建设“智慧山河”，让人们生活更美好！
                  </Text>
                </Box>
              </Flex>
            </Box>
            <Show above="lg"><Image src={aboutImage2} /></Show>
          </Flex>
          <Box mb="140px" bg="#fff" h={"294px"} position="relative">
            <Text
              position={"absolute"}
              top="0"
              left="0"
              lineHeight={"120px"}
              fontWeight="bold"
              fontSize={"144px"}
              color={"rgba(238, 241, 247, 0.5)"}
            >
              03
            </Text>
            <Flex
              ml="80px"
              mr="40px"
              h="100%"
              alignItems={"center"}
              position={"relative"}
            >
              <Box w="100%">
                <Text
                  mb="20px"
                  color={"#496AE1"}
                  fontSize="30px"
                  fontWeight={"bold"}
                >
                  VISION
                </Text>
                <Text mb="20px" color={"#3D3D3D"} fontSize="36px">
                  愿景
                </Text>
                <Text color={"#3D3D3D"} fontSize="20px">
                  基于“BIM+AIOT”的科技创新，成为全球建设行业数智时代的独角兽企业。
                </Text>
              </Box>
            </Flex>
          </Box>
        </Box>
      </Box>
      <Box
        backgroundImage={`url(${aboutBg})`}
        backgroundSize="100% auto"
        backgroundRepeat="no-repeat"
        w="100%"
        overflow={"hidden"}
      >
        <Center mt={8} mb={4}>
          <Image src={aboutTitle3} />
        </Center>
        <Box ml="78px" mr="78px" bg="#F9FAFC" p="25px 70px" mb="94px">
          <Box w="100%" sx={{ overflow: "auto" }} pb="10px">
            <Image w="2050px" h="606px" maxW={"none"} src={companyTimeLine} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
